import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getBoxCulvertsRows, MAX_BOX_CULVERT_SECTIONS } from "../../../utils/stormBuildUpBoxCulverts";
import { COLORS } from "../../../utils/constants";

type BoxCulvertsTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  onAddCulvert: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  culvertConfigMm?: Record<string, number>;
  culvertBackfillType?: Record<string, string>;
};

export default function BoxCulvertsTable({ sectionCount, onAddCulvert, onDeleteSection, onConfigureSection, culvertConfigMm, culvertBackfillType, ...props }: BoxCulvertsTableProps) {
  return (
    <div>
      <StormBuildUpTable
        rows={getBoxCulvertsRows(sectionCount, culvertConfigMm, culvertBackfillType)}
        onDeleteSection={onDeleteSection}
        onConfigureSection={onConfigureSection}
        {...props}
        showItemColumn
        sectionTitle="Height"
      />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddCulvert}
          disabled={sectionCount >= MAX_BOX_CULVERT_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Culvert
        </Button>
      </div>
    </div>
  );
}
